<template>
    <b-container>
        <b-row v-if="isIntuitApp" class="d4d-decoration">
        </b-row>
        <b-row v-if="isJAApp" class="ja-decoration">
        </b-row>
        <b-form @submit.prevent="register">
            <b-row class="d4d-login">
               
                <b-col cols="12" class="mt-1 title">Age Verification</b-col>
                <b-col cols="12" class="mt-4">
                    <p>
                        To comply with the U.S. Children's Online Privacy Protection Act, we will need consent from your parents or guardians before you can access this app.<br>
                        If your parent or guardian's email is not verify within 24h, you will have to start the sign-up process again.
                    </p>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <label for="email">Parent or Guardian Email Address</label>
                    <input id="email" type="text" v-model="form.email" value="">
                    <ul v-if="formEmailError.length" class="error-content">
                        <li class="error-text" v-for="error in formEmailError">{{ error }}</li>
                    </ul>
                </b-col>
                <b-col cols="12" class="mt-5 mb-4">
                    <b-button block variant="primary" type="submit">Email Consent</b-button>
                </b-col>
            </b-row>
        </b-form>
        <legal-message/>
    </b-container>
</template>

<script>
    import LegalMessage from "../Components/LegalMessage"
    import {UserService} from "../Services";

    export default {
        name: "AgeVerification",
        components:{LegalMessage},
        data() {
            return {
                form: {
                    email: null,
                    userId: this.$route.params.userId
                },
                formEmailError: []
            }
        },
        methods:{
            register(){
                const {email, userId} = this.form
                this.formEmailError = [];
                if(!email || !userId) this.formEmailError = ['This field is required']

                if(!this.formEmailError.length){
                    UserService.registerParentConsent(this.form).then(response =>{
                        this.$router.push({name: 'VerifyParentEmail'})
                    }).catch(error =>{
                        this.formEmailError = [];

                        if (error) {
                            if (error.message) {
                                this.formEmailError.push(error.message)
                            }
                            if (error.errors) {
                                if (error.errors['Email']) {
                                    error.errors['Email'].forEach(error => this.formEmailError.push(error))
                                }
                            }
                        }
                    })
                }

            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "../Styles/security_styles.styl"

    p
        font font-sourcesans-regular
        font-size 16px
        color color-4

</style>